import { render } from "./GetStartedText.vue?vue&type=template&id=0a98327a&scoped=true"
import script from "./GetStartedText.vue?vue&type=script&lang=js"
export * from "./GetStartedText.vue?vue&type=script&lang=js"

import "./GetStartedText.vue?vue&type=style&index=0&id=0a98327a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a98327a"]])

export default __exports__